export default {
    attribute:{
        defaultValueType: null,
        defaultValue: '',
        defaultValueEnd:'',
        defaultValueEN:'',
        defaultValueEndEN:'',
        timerange:false,
        timeFormat:'HH:mm:ss',
        label: '时间：',
        labelAlign:'right',
        labelWidth:100,
        placeholder: '请选择',
        size: 'medium', 
        width:144,
        height:32,
        align:"left",
        indent:0,
        bgColor: '#00000000',
        textColor: '#fff',
        textPlaceholderColor: '#333',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        textColor: '#ffffff',
        borderSize: 1,
        borderColor: '#333333',
        borderRadius: 0,
        lineType: 'solid',
        required: false,
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#fff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
        btnBg:"#2684ff",
        btnColor:"fff",
        panelColor:"#ffffff8c",
        timeIcon:true,
        timeIconBg:"#333",
        direction:'row',
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
    },
    cptDataForm: {
        dataText: '{"value":""}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    interaction: { eventText: '完成输入时' }
}